import isItemToString from './is_item_to_string';
const nullItemToString = ({
  is
}) => `${isItemToString(is)}null`;
export default nullItemToString;
//# sourceMappingURL=null_item_to_string.js.map